import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react';

export const useStateCallback = <T>(initialState: T): [T, SetStateCallback<T>] => {
  const [state, setState] = useState<T>(initialState);
  const cbRef = useRef<CallbackFunction<T> | null>(null);

  const setStateCallback = useCallback((state, cb) => {
    cbRef.current = cb;
    setState(state);
  }, []);

  useEffect(() => {
    if (cbRef.current) {
      cbRef.current(state);
      cbRef.current = null;
    }
  }, [state]);

  return [state, setStateCallback];
};

type CallbackFunction<T> = (state: T) => void;

type SetStateCallback<T> = (state: T | SetStateAction<T>, cb?: CallbackFunction<T>) => void;
